import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

const plans = [
  {
    id: "guia",
    name: "Guía Independiente",
    description: "Ideal para operadores que trabajan solos o con un asistente.",
    price: 11000,
    currency: "CRC",
    features: [
      "1 Cuenta de usuario",
      "Hasta 10 tours",
      "Calendario",
      "Perfil público",
      "Pagos en línea",
    ],
    color: "bg-blue-600 hover:bg-blue-700",
  },
  {
    id: "equipo",
    name: "Equipo Pequeño",
    description: "Ideal para pequeñas empresas.",
    price: 20000,
    currency: "CRC",
    features: [
      "Cuenta de usuario",
      "más de 10 tours",
      "Calendario",
      "Perfil público",
      "Pagos en línea",
    ],
    color: "bg-green-600 hover:bg-green-700",
  },
];

const formatPrice = (amount) =>
  new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
    minimumFractionDigits: 0,
  }).format(amount);

export default function SubscriptionPlansPage() {
  const navigate = useNavigate();

  const handleSelectPlan = (plan) => {
    // Navegar a la página de pago con el plan seleccionado
    navigate("/checkout", { state: { selectedPlan: plan } });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50">
      <motion.h1
        className="text-4xl font-bold mb-6 text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Escoge tu Plan
      </motion.h1>

      <div className="grid md:grid-cols-2 gap-8 w-full max-w-5xl">
        {plans.map((plan, i) => (
          <motion.div
            key={plan.id}
            className="bg-white p-6 rounded-lg shadow flex flex-col justify-between"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
          >
            <div>
              <h2 className="text-2xl font-semibold mb-2">{plan.name}</h2>
              <p className="text-gray-600 mb-4">{plan.description}</p>
              <p className="text-gray-900 font-bold">
                Precio: {formatPrice(plan.price)} / {plan.currency}
              </p>
              <ul className="space-y-2 mb-4">
                {plan.features.map((f, idx) => (
                  <li key={idx} className="flex items-center">
                    <CheckCircle className="text-green-500 mr-2" size={18} />
                    {f}
                  </li>
                ))}
              </ul>
            </div>

            <button
              onClick={() => handleSelectPlan(plan)}
              className={`w-full py-2 text-white font-semibold rounded ${plan.color}`}
            >
              Seleccionar Plan
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}